import { GetLoginInfoResponse, getLoginInfo } from '@otter-ai/recall-client';
import { QueryOptions, QueryResult } from './types';

type LoginInfoQueryKey = ['loginInfo'];

/**
 * Create a query to fetch the user's login info
 *
 * @example
 * ```tsx
 * const { data: loginInfo } = useQuery(loginInfoQueryCreator());
 * ```
 */

export function loginInfoQueryCreator(
  additionalOptions: QueryOptions<GetLoginInfoResponse, LoginInfoQueryKey> = {},
): QueryResult<GetLoginInfoResponse, LoginInfoQueryKey> {
  return {
    ...additionalOptions,
    queryKey: ['loginInfo'],
    queryFn: async () => {
      const response = await getLoginInfo({ throwOnError: true });
      return response.data;
    },
  };
}
